import { gql } from "../__generated__";

export const GetObjectPublications = gql(`
  query GetObjectPublications($take: Int, $where: ObjektEigenschaftPublikationWhereInput) {
    items: objektEigenschaftPublikations(take: $take, where: $where) {
      id
      name
    }
  }
`);
